/**
 * A company's team: the two staff roles a user of a business tenant holds.
 *
 * `user_tenants.role` also holds citizen roles (`citizen`, `talent`) for the
 * citizen tenants, so a company's team is the rows with one of these — never
 * every row of the tenant. The API validates invitations against it, the
 * team read filters on it and business-web names each role through it.
 */
export const BUSINESS_TEAM_ROLES = ['business_admin', 'business_user'] as const;
export type BusinessTeamRole = (typeof BUSINESS_TEAM_ROLES)[number];

export const isBusinessTeamRole = (role: string): role is BusinessTeamRole =>
  (BUSINESS_TEAM_ROLES as readonly string[]).includes(role);

/**
 * Each team role's name — the one map business-web names a role through
 * (`t(BUSINESS_TEAM_ROLE_LABEL_KEY[role])`), guarded against en.json in
 * dynamic-key-coverage.spec.ts.
 */
export const BUSINESS_TEAM_ROLE_LABEL_KEY = {
  business_admin: 'business.businessSettings.team.roleAdmin',
  business_user: 'business.businessSettings.team.roleTeamMember',
} as const satisfies Record<BusinessTeamRole, string>;
